import React from "react";
import {
  Inbox, CheckCircle2, Cog, MessageSquare, UserX, AlertTriangle, Clock, CalendarClock,
} from "lucide-react";

const CARDS = [
  { key: "received_today", label: "Received Today", icon: Inbox },
  { key: "received_week", label: "Received This Week", icon: Inbox },
  { key: "calibrated_today", label: "Calibrated Today", icon: CheckCircle2 },
  { key: "calibrated_week", label: "Calibrated This Week", icon: CheckCircle2 },
  { key: "awaiting_spares", label: "Awaiting Spares", icon: Cog },
  { key: "awaiting_customer", label: "Awaiting Customer", icon: MessageSquare },
  { key: "unassigned_gt2", label: "Unassigned > 2 Days", icon: UserX },
  { key: "overdue", label: "Overdue", icon: AlertTriangle, critical: true },
  { key: "avg_days_in_lab", label: "Average Days in Lab", icon: Clock, suffix: "d", notClickable: true },
  { key: "due_for_calibration", label: "Due for Calibration", icon: CalendarClock },
];

// KPI cards double as filters — clicking one filters the work table below;
// clicking the same one again clears it.
export function TechKpiCards({ kpis, activeKpi, onSelect }) {
  return (
    <div className="td-kpi-grid" data-testid="td-kpi-grid">
      {CARDS.map(({ key, label, icon: Icon, critical, suffix, notClickable }) => {
        const active = activeKpi === key;
        const val = kpis ? kpis[key] : null;
        const isOverdueCard = critical && val > 0;
        return (
          <div
            key={key}
            className={`td-kpi-card ${active ? "active" : ""} ${notClickable ? "static" : ""}`}
            data-testid={`td-kpi-${key}`}
            onClick={notClickable ? undefined : () => onSelect(active ? null : key)}
            title={notClickable ? label : `Filter to ${label}`}
          >
            <Icon size={16} color={isOverdueCard ? "var(--red)" : "var(--gold-deep)"} />
            <div className="td-kpi-lbl">{label}</div>
            <div className="td-kpi-val" style={{ color: isOverdueCard ? "var(--red)" : "var(--text)" }}>
              {kpis ? `${val ?? 0}${suffix || ""}` : "—"}
            </div>
          </div>
        );
      })}
      {activeKpi && (
        <button className="td-kpi-clear" onClick={() => onSelect(null)} data-testid="td-kpi-clear">
          Clear KPI filter
        </button>
      )}
    </div>
  );
}
